export default __webpack_public_path__ + "static/media/ic_caret_down.c0b5e6d8.svg";